import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { PercentageMaskOptions } from '@boldpenguin/emperor-form-fields';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ComplianceFormQuestionGroup } from 'src/app/core/models/compliance-form.model';
import {
  MixpanelEventType,
  MixpanelService,
} from 'src/app/core/services/mixpanel-service/mixpanel.service';
import { selectLogoPathForEnrollmentBySubdomain } from 'src/app/core/store/enrollments/enrollments.selectors';
import { AttuneComplianceQuestionKeys } from 'src/app/shared/models/shared-compliance-form-questions';
import { usStatesFullNameForEmperorChoices } from '../../models/us-states-model';

@Component({
  selector: 'app-attune-compliance-questions',
  templateUrl: './attune-compliance-questions.component.html',
  styleUrls: ['./attune-compliance-questions.component.scss'],
})
export class AttuneComplianceQuestionsComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;

  carrierLogo$: Observable<string>;

  readonly AttuneComplianceQuestionKeys = AttuneComplianceQuestionKeys;
  readonly stateChoices = usStatesFullNameForEmperorChoices();
  readonly percentageMask = { ...PercentageMaskOptions, radix: '.' };

  constructor(
    private store: Store,
    private mixpanelService: MixpanelService,
  ) {}

  ngOnInit(): void {
    this.mixpanelService.track(
      MixpanelEventType.COMPLIANCE_ATTUNE_QUESTIONS_LOADED,
    );
    this.carrierLogo$ = this.store.pipe(
      select(
        selectLogoPathForEnrollmentBySubdomain(
          ComplianceFormQuestionGroup.ATTUNE,
        ),
      ),
    );
  }
}
